import React from 'react';
import { Landmark } from 'lucide-react';

const HistorySection = () => {
    return (
        <section className="bg-white py-20 px-4 border rounded-lg shadow-lg max-w-5xl mx-auto mb-16">
            <div className="text-center mb-10">
                <h1
                    className="text-4xl md:text-5xl font-extrabold text-gray-800"
                    data-aos="fade-down"
                >
                    History of Ibadan South Diocese
                </h1>
                <hr
                    className="w-24 border-t-2 border-blue-500 mx-auto mt-3"
                    data-aos="fade-down"
                    data-aos-delay="200"
                />
            </div>

            <div className="bg-gray-50 rounded-lg p-8" data-aos="fade-up">
                <h2 className="text-2xl font-bold text-red-600 text-center mb-4" data-aos="fade-up">
                    <Landmark className="inline-block w-6 h-6 mr-1" />
                    Our Origins and Milestones
                </h2>
                <hr className="w-20 border-t-2 border-red-500 mx-auto mb-6" data-aos="fade-down" data-aos-delay="200" />

                <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                    <p data-aos="fade-up" data-aos-delay="300">
                        The <strong>Diocese of Ibadan South</strong>, a vibrant arm of the Anglican Communion in Nigeria,
                        was carved out of the Diocese of Ibadan in <strong>July, 1999</strong>. This strategic creation aimed to foster
                        effective administration and growth of the Church in the southern regions of Ibadan.
                    </p>

                    <p data-aos="fade-up" data-aos-delay="400">
                        The Diocese officially began its journey under the leadership of <strong>The Rt. Rev. Jacob Ajetunmobi</strong>,
                        whose vision laid a strong foundation for spiritual growth and community development. Over the years, the Diocese
                        has expanded significantly with numerous parishes and outreach initiatives.
                    </p>

                    <p data-aos="fade-up" data-aos-delay="500">
                        Guided by the principles of biblical truth, Ibadan South Diocese remains committed to the mission of
                        leading souls to Christ, promoting unity among believers, and addressing societal needs through various
                        programs — including education, healthcare, and community welfare.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default HistorySection;
